// @flow
export const CHANGE_VIEW = "booking/CHANGE_VIEW"
export const SET_MODAL_OPEN = "booking/SET_MODAL_OPEN"
export const TOGGLE_TIMELINE = "booking/TOGGLE_TIMELINE"
export const CLEAR_ERROR = "booking/CLEAR_ERROR"
export const CLEAR_SUCCESS = "booking/CLEAR_SUCCESS"
export const LOAD = "booking/LOAD"
export const LOAD_REQUEST = "booking/LOAD_REQUEST"
export const LOAD_SUCCESS = "booking/LOAD_SUCCESS"
export const LOAD_FAILURE = "booking/LOAD_FAILURE"
export const LOAD_SEATS = "booking/LOAD_SEATS"
export const LOAD_SEATS_REQUEST = "booking/LOAD_SEATS_REQUEST"
export const LOAD_SEATS_SUCCESS = "booking/LOAD_SEATS_SUCCESS"
export const LOAD_SEATS_FAILURE = "booking/LOAD_SEATS_FAILURE"
export const RELOAD = "booking/RELOAD"
export const RELOAD_REQUEST = "booking/RELOAD_REQUEST"
export const RELOAD_SUCCESS = "booking/RELOAD_SUCCESS"
export const RELOAD_FAILURE = "booking/RELOAD_FAILURE"
export const RESET = "booking/RESET"
export const ACTION = "booking/ACTION"
export const ACTION_SUCCESS = "booking/ACTION_SUCCESS"
export const ACTION_REQUEST = "booking/ACTION_REQUEST"
export const ACTION_FAILURE = "booking/ACTION_FAILURE"
export const INVALIDATE_START = "booking/INVALIDATE_START"
export const INVALIDATE_END = "booking/INVALIDATE_END"
